import React from 'react';
import './EfficiencyClass.styles.css';
import { Provider } from 'react-redux';
import EfficiencyButton from './EfficiencyButton';
import { store } from '../../store/store';

const EfficiencyButtonWrapper = ({ exposeId, lastModificationDate }: { exposeId: string, lastModificationDate: string }) => {
  return (
    <Provider store={store}>
      <EfficiencyButton exposeId={exposeId} lastModificationDate={lastModificationDate} />
    </Provider>
  );
};

export default EfficiencyButtonWrapper;
